import React from 'react';

const CurrentUserContext = React.createContext({
  currentUser: {},
  handleSetUser: () => {
  },
});

export default CurrentUserContext;
